export interface TruemedHIWProps {}

export const defaultSteps = [
	{
		eyebrow: 'step 1',
		title: 'Add to Cart',
		content: 'Add the Pod to your cart and proceed to checkout.',
		url: 'https://eightsleep.imgix.net/assets/tm_step1.png',
	},
	{
		eyebrow: 'step 2',
		title: 'Select pay with HSA/FSA',
		content: 'Select "Pay with HSA/FSA" as your payment option at checkout',
		url: 'https://eightsleep.imgix.net/assets/tm_step2.png',
	},
	{
		eyebrow: 'step 3',
		title: 'Take quick survey',
		content: 'Take a quick health survey to determine eligibility.',
		url: 'https://eightsleep.imgix.net/assets/tn_step3.png',
	},
	{
		eyebrow: 'step 4',
		title: 'Choose your payment method',
		content: 'Use your FSA or HSA card as you would any other credit card. Alternatively, use your own credit card for reimbursement through TrueMed.',
		url: 'https://eightsleep.imgix.net/assets/tn_step4.png',
	},
]
